import {
  APPROVER_FETCHED,
  APPROVER_INFO,
  APPROVER_LOCATIONS,
  SET_APPROVER,
} from "../types";

const initialState = {
  approverData: [] as any,
  singleApprover: {},
  approverInfo: {},
  locations: [] as any,
};
const approvers = (state = initialState, action: any) => {
  switch (action.type) {
    case APPROVER_FETCHED:
      return {
        ...state,
        approverData: action.approverData,
        loading: false,
      };
    case APPROVER_INFO:
      return {
        ...state,
        approverInfo: action.approverInfo,
      };
    case APPROVER_LOCATIONS:
      return {
        ...state,
        locations: action.locations,
      };
    case SET_APPROVER:
      return {
        ...state,
        singleApprover: action.singleApprover,
      };
    default:
      return state;
  }
};

export default approvers;



